export const formatSearchInput = () => {
    return new Promise((resolve, reject) => {
        document.querySelector('predictive-search-drawer')?.remove();
        const header = document.querySelector('.shopify-section--header');
        header.style.zIndex = 6;

        const nostoSearchOverlay = document.createElement('div');
        nostoSearchOverlay.setAttribute('id', 'nosto-search-overlay');

        const backdrop = document.createElement('div');
        backdrop.classList.add('search-backdrop')
        const content = document.createElement('div');
        content.classList.add('search-content')

        const form = document.createElement('form');
        form.classList.add('nosto-search-form')

        const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        icon.setAttribute("focusable", "false");
        icon.setAttribute("width", "18");
        icon.setAttribute("height", "18");
        icon.setAttribute("class", "icon icon--header-search");
        icon.setAttribute("viewBox", "0 0 18 18");
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", "M12.336 12.336c2.634-2.635 2.682-6.859.106-9.435-2.576-2.576-6.8-2.528-9.435.106C.373 5.642.325 9.866 2.901 12.442c2.576 2.576 6.8 2.528 9.435-.106zm0 0L17 17");
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "currentColor");
        path.setAttribute("stroke-width", "1.2");
        icon.appendChild(path);
        form.appendChild(icon);

        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('id', 'nosto-search-input');
        input.setAttribute('name', 'q');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('aria-label', 'Search');
        input.setAttribute('placeholder', 'What are you looking for?');
        form.appendChild(input);

        const closeBtn = document.createElement('button');
        closeBtn.setAttribute('type', 'button');
        closeBtn.setAttribute('class', 'drawer__close-button tap-area');
        closeBtn.setAttribute('data-action', 'close');
        closeBtn.setAttribute('title', 'Close');
        const closeSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        closeSvg.setAttribute('focusable', 'false');
        closeSvg.setAttribute('width', '14');
        closeSvg.setAttribute('height', '14');
        closeSvg.setAttribute('class', 'icon icon--close');
        closeSvg.setAttribute('viewBox', '0 0 14 14');
        const closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        closePath.setAttribute('d', 'M13 13L1 1M13 1L1 13');
        closePath.setAttribute('stroke', 'currentColor');
        closePath.setAttribute('stroke-width', '1.2');
        closePath.setAttribute('fill', 'none');
        closeSvg.appendChild(closePath);
        closeBtn.appendChild(closeSvg);

        content.appendChild(closeBtn);
        content.appendChild(form);
        nostoSearchOverlay.appendChild(content);
        nostoSearchOverlay.appendChild(backdrop);
        header.insertAdjacentElement('beforeend', nostoSearchOverlay);

        const toggleOverlay = () => {
            if(nostoSearchOverlay.classList.contains('active')) {
                nostoSearchOverlay.classList.remove('active');
                document.querySelector('html').classList.remove('lock-all');
                setTimeout(() => {
                    document.querySelector('.nosto-search-form').reset();
                }, 250)
            } else {
                nostoSearchOverlay.classList.add('active');
                document.querySelector('html').classList.add('lock-all');
                setTimeout(() => {
                    document.querySelector('#nosto-search-input').focus();
                }, 250)
            }
        };

        const handleSearchClick = (event) => {
            // calculate max-height for autocomplete (banners + navbar)
            const eleRef = document.querySelector('#nosto-search-overlay .search-content')
            if(eleRef) {
                setTimeout(() => {
                    const spacing = eleRef.getBoundingClientRect().bottom ;
                    eleRef.style.setProperty('--top-spacing', spacing + 'px');
                }, 250)
            }

            toggleOverlay();
        }

        closeBtn.addEventListener('click', toggleOverlay);
        backdrop.addEventListener('click', toggleOverlay);
        document.querySelectorAll('.header__icon-wrapper[aria-label="Search"]').forEach(btn => {
            btn.addEventListener('click', handleSearchClick)
        });

        if(document.contains(document.getElementById('nosto-search-overlay'))) {
            resolve({ success: true });
        } else {
            reject(new Error('Nosto search input was not formatted correctly.'))
        }
    });
}